import { useEffect } from 'react'

export const useBodyScrollAbility = (isShown: boolean) => {
  useEffect(() => {
    if (isShown) {
      document.body.style.overflowY = 'hidden'
    }

    return () => {
      document.body.style.overflowY = 'unset'
    }
  }, [isShown])
}
